import { Navigate } from "react-router-dom";

const Logedout = ({ children } :any) => {

    if (JSON.parse(localStorage.getItem("user") as string) !== "null") {
        return <Navigate to="/accountsettingpage" />;
    }

    return children;
};

export default Logedout;